module.exports = __webpack_public_path__ + "img/lv13.527294f0.png";